define("shared/components/shared/linkinbio/slug-validator/task", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/service", "@ember/utils", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "later/utils/constants", "later/utils/fetch", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _service, _utils, _component2, _tracking, _emberConcurrency, _constants, _fetch, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _markInvalid;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/service",0,"@ember/utils",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"later/utils/constants",0,"later/utils/fetch",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
  function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _classPrivateMethodGet(s, a, r) { return _assertClassBrand(a, s), r; }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  {{yield (hash errorMessage=this.errorMessage isValid=this.isValid slug=this.slug validate=this.validate)}}
  */
  {
    "id": "psPrKS73",
    "block": "[[[18,1,[[28,[37,1],null,[[\"errorMessage\",\"isValid\",\"slug\",\"validate\"],[[30,0,[\"errorMessage\"]],[30,0,[\"isValid\"]],[30,0,[\"slug\"]],[30,0,[\"validate\"]]]]]]]],[\"&default\"],false,[\"yield\",\"hash\"]]",
    "moduleName": "shared/components/shared/linkinbio/slug-validator/task.hbs",
    "isStrictMode": false
  });
  const DEBOUNCE_TIME = 500;
  const MINIMUM_CHARACTERS = 2;
  const ONE_MILLISECOND = 1;
  let SlugValidatorTaskComponent = _exports.default = (_class = (_markInvalid = /*#__PURE__*/new WeakSet(), class SlugValidatorTaskComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);
      _classPrivateMethodInitSpec(this, _markInvalid);
      _initializerDefineProperty(this, "intl", _descriptor, this);
      _initializerDefineProperty(this, "errorMessage", _descriptor2, this);
      _initializerDefineProperty(this, "slug", _descriptor3, this);
      _defineProperty(this, "initialSlug", void 0);
      _defineProperty(this, "validate", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          const waitForNextRunloop = async () => await (0, _emberConcurrency.rawTimeout)(ONE_MILLISECOND);
          let message = undefined;
          yield waitForNextRunloop();
          _classPrivateMethodGet(this, _markInvalid, _markInvalid2).call(this, message);
          if (!this.args.validateInitialSlug && this.initialSlug === this.slug && Boolean(this.slug)) {
            return;
          }
          yield (0, _emberConcurrency.timeout)(DEBOUNCE_TIME);
          if (!(0, _utils.isPresent)(this.slug)) {
            message = this.intl.t('linkinbio.choose_your_handle.error.empty');
          } else if (this.slug.length < MINIMUM_CHARACTERS) {
            message = this.intl.t('linkinbio.choose_your_handle.error.short');
          } else if (!new RegExp(_constants.LINKINBIO_HANDLE_VALIDATION_REGEX).test(this.slug)) {
            message = this.intl.t('linkinbio.choose_your_handle.error.characters');
          } else if (yield this.args.isDisallowed?.(this.slug)) {
            message = this.intl.t('linkinbio.choose_your_handle.error.disallowed');
          } else {
            try {
              yield (0, _fetch.fetch)(`api/v2/linkinbio_pages/slug_verify?slug=${this.slug.toLowerCase()}`);
              this.args.onValid?.(this.slug.toLowerCase());
            } catch (error) {
              message = this.intl.t('linkinbio.choose_your_handle.error.unavailable');
              _classPrivateMethodGet(this, _markInvalid, _markInvalid2).call(this, message);
              return;
            }
          }
          if (message) {
            _classPrivateMethodGet(this, _markInvalid, _markInvalid2).call(this, message);
          }
        }
      }), null, "validate", "restartable"));
      this.initialSlug = this.args.slug;
      this.slug = this.args.slug || '';
      if (this.args.validateInitialSlug) {
        this.validate.perform();
      }
    }
    get isValid() {
      return !this.validate.isRunning && !this.errorMessage && !this.args.isDisabled;
    }
  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "errorMessage", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "slug", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  function _markInvalid2(message) {
    this.args.onInvalid?.(message);
    this.errorMessage = message;
  }
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, SlugValidatorTaskComponent);
});